module.exports = {
          srcSet: __webpack_public_path__ + "public/images/3dd2e65b90b4fa001b2bea07a841c130-1920.webp"+" 1920w",
          images:[ {path: __webpack_public_path__ + "public/images/3dd2e65b90b4fa001b2bea07a841c130-1920.webp",width: 1920,height: 881}],
          src: __webpack_public_path__ + "public/images/3dd2e65b90b4fa001b2bea07a841c130-1920.webp",
          toString:function(){return __webpack_public_path__ + "public/images/3dd2e65b90b4fa001b2bea07a841c130-1920.webp"},
          
          width: 1920,
          height: 881
        }